<script setup lang="ts">
import OmniDialog from "@/components/omni/OmniDialog.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { DialogSize } from "@/constants/dialog";
import { useAppStore } from "@/store/app.store";
import { useChat } from "@/composables/useChat";
import type { ChatStateThread } from "@/store/chat.store";

const props = withDefaults(
  defineProps<{
    thread: ChatStateThread;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const { t } = useI18n();
const appStore = useAppStore();
const { resolveThread } = useChat();

const dialogVisible = ref(false);

async function clickResolveThread() {
  if (props.thread.dispatcherId && props.thread.dispatcherId !== appStore.dispatcher?.id && !props.thread.resolved) {
    dialogVisible.value = true;
  } else {
    await resolveThread(props.thread);
  }
}

async function doResolveThread() {
  await resolveThread(props.thread);
  dialogVisible.value = false;
}
</script>

<template>
  <v-btn
    v-if="!thread.resolved"
    :disabled="disabled"
    class="mr-2"
    color="success"
    size="small"
    variant="outlined"
    @click="clickResolveThread"
  >
    <v-icon class="mr-1">mdi-check</v-icon>
    <span class="font-weight-600 text-uppercase text-success">
      {{ t("dispatchers.resolve") }}
    </span>
  </v-btn>
  <omni-dialog
    v-model="dialogVisible"
    primary-action-label="Resolve"
    :size="DialogSize.small"
    title="Pay attention!"
    @primary-action:click="doResolveThread"
  >
    <div class="text-body-2 text-left text-grey text-grey-darken-1">
      If you want to resolve this chat from
      <span v-if="thread.dispatcher">{{ thread.dispatcher.name }}</span>
      please press “Resolve”!
    </div>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
